<template>
  <div class="hamburger">
    <img v-if="!isWhite" class="hamburger-image" src="@/assets/hamburger_b.png"/>
    <img v-else class="hamburger-image" src="@/assets/hamburger_w.png"/>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isWhite: Boolean
  }
}
</script>

<style scoped>
.hamburger {
  padding: 48px 64px 0 64px;
}
.hamburger-image {
  width: 32px;
  height: 12px;
  padding: 10px 0;
}
@media (max-width: 639px) {
  .hamburger {
    padding: 24px 24px 0 24px;
  }
  .hamburger-image {
    width: 24px;
    height: 9px;
    padding: 7.5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Hamburger.vue